import {
    GET_SCHOOLS_LISTING,
    GET_SCHOOLS_LISTING_SUCCESS,
    GET_SCHOOLS_LISTING_FAIL,
    GET_SCHOOLS_DETAILS,
    GET_SCHOOLS_DETAILS_SUCCESS,
    GET_SCHOOLS_DETAILS_FAIL,
    ADD_SCHOOLS,
    ADD_SCHOOLS_SUCCESS,
    ADD_SCHOOLS_FAIL,
    UPDATE_SCHOOLS,
    UPDATE_SCHOOLS_SUCCESS,
    UPDATE_SCHOOLS_FAIL,
    DELETE_SCHOOLS,
    DELETE_SCHOOLS_SUCCESS,
    DELETE_SCHOOLS_FAIL,
    BULK_DELETE_SCHOOLS,
    BULK_DELETE_SCHOOLS_SUCCESS,
    BULK_DELETE_SCHOOLS_FAIL,
    EXPORT_SCHOOLS,
    EXPORT_SCHOOLS_SUCCESS,
    EXPORT_SCHOOLS_FAIL,
    RESET_SCHOOLS_STATE,
    RESET_SCHOOLS_ATTACHMENT_STATE,
} from "./actionTypes";

export const getSchoolsListing = (payload) => ({
    type: GET_SCHOOLS_LISTING,
    payload: payload
});

export const getSchoolsListingSuccess = categories => ({
    type: GET_SCHOOLS_LISTING_SUCCESS,
    payload: categories,
});

export const getSchoolsListingFail = error => ({
    type: GET_SCHOOLS_LISTING_FAIL,
    payload: error,
});

export const getSchoolsDetails = schoolsId => ({
    type: GET_SCHOOLS_DETAILS,
    payload: schoolsId,
});

export const getSchoolsDetailsSuccess = schools => ({
    type: GET_SCHOOLS_DETAILS_SUCCESS,
    payload: schools,
});

export const getSchoolsDetailsFail = error => ({
    type: GET_SCHOOLS_DETAILS_FAIL,
    payload: error,
});

export const createSchools = schools => ({
    type: ADD_SCHOOLS,
    payload: schools,
});

export const createSchoolsSuccess = schools => ({
    type: ADD_SCHOOLS_SUCCESS,
    payload: schools,
});

export const createSchoolsFail = error => ({
    type: ADD_SCHOOLS_FAIL,
    payload: error,
});

export const updateSchools = schools => ({
    type: UPDATE_SCHOOLS,
    payload: schools,
});

export const updateSchoolsSuccess = schools => ({
    type: UPDATE_SCHOOLS_SUCCESS,
    payload: schools,
});

export const updateSchoolsFail = error => ({
    type: UPDATE_SCHOOLS_FAIL,
    payload: error,
});

export const deleteSchools = schoolsId => ({
    type: DELETE_SCHOOLS,
    payload: schoolsId,
});

export const deleteSchoolsSuccess = schoolsId => ({
    type: DELETE_SCHOOLS_SUCCESS,
    payload: schoolsId,
});

export const deleteSchoolsFail = error => ({
    type: DELETE_SCHOOLS_FAIL,
    payload: error,
});

export const bulkDeleteSchools = schoolsId => ({
    type: BULK_DELETE_SCHOOLS,
    payload: schoolsId,
});

export const bulkDeleteSchoolsSuccess = schoolsId => ({
    type: BULK_DELETE_SCHOOLS_SUCCESS,
    payload: schoolsId,
});

export const bulkDeleteSchoolsFail = error => ({
    type: BULK_DELETE_SCHOOLS_FAIL,
    payload: error,
});

export const exportSchools = (payload) => ({
    type: EXPORT_SCHOOLS,
    payload: payload
});

export const exportSchoolsSuccess = data => ({
    type: EXPORT_SCHOOLS_SUCCESS,
    payload: data,
});

export const exportSchoolsFail = error => ({
    type: EXPORT_SCHOOLS_FAIL,
    payload: error,
});

//reset
export const resetSchoolsState = () => {
    return {
        type: RESET_SCHOOLS_STATE,
    }
}
//reset attachment
export const resetSchoolsAttachmentState = () => {
    return {
        type: RESET_SCHOOLS_ATTACHMENT_STATE,
    }
}

